module.exports = __webpack_public_path__ + "static/fonts/Fact-CompressedExtraLight.46b9ef1.woff2";